import { css } from '@emotion/react'
import { PanelLeft } from 'lucide-react'
import { useObserveAriaExpandedNav } from './useObserveAriaExpandedNav'

const drawerButtonStyles = css`
  transition-property: opacity, height;
  transition-duration: 0.5s, 0.5s;
  transition-timing-function: ease-in-out, ease-in-out;

  &.-is-menu-item {
    // Different transition delay depending on its starting state of opened or closed.
    .page-with-nav__drawer[aria-expanded='false'] & {
      transition-delay: 0.5s, 0s;
    }

    .page-with-nav__drawer[aria-expanded='true'] & {
      transition-delay: 0s, 0.3s;
    }

    height: 38px;

    .page-with-nav__drawer[aria-expanded='false'] & {
      opacity: 1;
      height: 38px;
    }

    .page-with-nav__drawer[aria-expanded='true'] & {
      opacity: 0;
      height: 15px;
    }
  }

  &.-is-not-menu-item {
    transition: opacity 200ms ease-in-out;
    transition-delay: 0s;

    .page-with-nav__drawer[aria-expanded='false'] & {
      opacity: 0;
    }

    .page-with-nav__drawer[aria-expanded='true'] & {
      opacity: 1;
    }
  }
`

interface MenuDrawerButtonProps {
  isMenuItem?: boolean
  onClick: () => void
  getMenuExpandedStatus: () => boolean
}

export const MenuDrawerButton = ({
  isMenuItem = false,
  onClick,
  getMenuExpandedStatus,
}: MenuDrawerButtonProps) => {
  const dynamicClasses = isMenuItem
    ? '-is-menu-item mx-3 w-[40px]'
    : '-is-not-menu-item absolute top-[20px] right-[-16px] z-[999]'
  const ariaExpandedValue = useObserveAriaExpandedNav({ getMenuExpandedStatus })

  return (
    <button
      className={`page-with-nav__menu-drawer-button ${dynamicClasses} bg-cv-500 p-2 text-cv-blue-100 bg-cv-blue-500 rounded-md hover:brightness-125 transition-all ease-in-out duration-200`}
      type="button"
      onClick={onClick}
      css={drawerButtonStyles}
      aria-controls="page-with-nav-drawer"
      aria-expanded={ariaExpandedValue}
    >
      <PanelLeft strokeWidth={1.5} size={16} style={{ margin: '0 auto' }} />
    </button>
  )
}
